export default __webpack_public_path__ + "static/media/ufi.269833d5.svg";